var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotationLock2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_2465_67266)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2465_67266",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2465_67266",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2465_67266",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAp5JREFUWIXFl0trFFEQhU9PspjRiLgwCEYRBZMf4MYXYh66UHxA/kWIoMQkayGDBPwHQXCjIEEE0V2yyBPRhahgMLhQZmEMUdRFyAzJ56Krnc6kH7cnE1Iw9HCrzqlz69btvlfaZfNcgoAmSWckXZd0VtJxSQckVSQtSypJmpU0KWnS87xKQ9QBBWAQWMLdSsAwsH+7yXuBbyHiBeA+0AV0AHuBPcAxoBsoAu9rhFypJ3EOGAE2jOgN0JkB3wNMh4Q8AJyWOkj+xIBloM8ZvJXnNrBqXI+sj1KBIwb4CVzMmjiC7wLw1ziLacG9VvZyUnLgCDAO/LHfM6A9If48sGbc1+KCCqGG60tJvhLR+StAWwLujsV9BQpRAYOhhotdc5s5wEvgMNAGvLKxpwk4D5i3uKFaZxPVfZ7Y7VZywrO1qgD8TsFeDlWhGZgDpoI1AlhIIjASAFzHzTdjlW0FPllo0Z6LOfmvV0l6niagTstLOiVpQtK8jQ3b86FCa9MdxwDMRjRenE3XYFuBD+ZbDcWVgUMCftjAyQQBmSwCHxYR2HjgXLOBljQBcX6XOOAgm78Vl2oF7NtJAeZvxW/IGSAXDAZbMHUJtisgynKSvtj/o1mAjbKc/JOMJPXshgAB56xyiwkxO7YEta/iriRiV8skwBLcNey7/9252T8dn26LTdUjII//kQDoz0zQCANu4h8aKnFLUSdvHmh2Db5nVfjVCBFAJ7AMTLgCPOCxiagAt6J6wpGn3zgAxrKCh4B1A38ErmbAdwNvDbuBf5fIPImgJ4LGBPgMjOKf+zuAFvzLSbslHaV64AD/jHkjc+IaEXlgAPjuuAXBf6cMAHmXHK6X05yk06peTk+oejktSVqS9FrSC0lznuet1zHf3bF/uETc12WCA9UAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotationLock2);
export default __webpack_public_path__ + "static/media/rotation-lock-2.a5825a58291a1e8ac4dbc6cc5f4fab65.svg";
export { ForwardRef as ReactComponent };